import React from "react"

import globalStyles from "../../../../App.module.scss";
import merge from './images/merge.png'
import {Prism as SyntaxHighlighter} from "react-syntax-highlighter";
import {dracula} from "react-syntax-highlighter/dist/cjs/styles/prism";

export default function PdfMerger() {

    let data = `import argparse

from pypdf import PdfWriter


def merge_pdfs(input_paths: list[str], output_path: str) -> None:
    writer = PdfWriter()
    for path in input_paths:
        writer.append(path)
    with open(output_path, "wb") as f:
        writer.write(f)


def main():
    parser = argparse.ArgumentParser(description="Merge multiple PDF files into one")
    parser.add_argument("inputs", nargs="+", help="PDF files to merge, in order")
    parser.add_argument("-o", "--output", default="merged.pdf")
    args = parser.parse_args()

    merge_pdfs(args.inputs, args.output)
    print(f"Merged {len(args.inputs)} file(s) -> {args.output}")


if __name__ == "__main__":
    main()
`

    return (
        <div className={globalStyles.article}>
            <h1>PDF merger</h1>
            <p>Combines several PDF files into a single document, in the order given on the command line.</p>
            <p>Requires the <code>pypdf</code> package: <code>pip install pypdf</code></p>
            <div style={{maxWidth: '800px'}}>
                <SyntaxHighlighter
                    children={data}
                    style={dracula}
                    PreTag="div"
                    language={'python'}
                />
            </div>

            <p>The program above produces the next output:</p>
            <div style={{maxWidth: '800px'}}>
                <img src={merge} alt={""}/>
            </div>
        </div>
    )
}
